import React from 'react';
import { Container, Divider } from '@fiverr-private/layout_components';
import { DisplayFromValue } from '../../shared/constants';

interface NavDividerProps {
    displayFrom: DisplayFromValue;
}

export const NavDivider = ({ displayFrom }: NavDividerProps) => (
    <Container
        height="100%"
        paddingTop="2.5"
        paddingBottom="2.5"
        display="flex"
        hidden={{ default: true, [displayFrom]: false }}
    >
        <Divider direction="vertical" />
    </Container>
);
